import PropTypes from "prop-types";
import React from "react";
import { MSpinner, ReadOnlyField } from "components/Shared";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const Profile = ({ isFetching, profile, userProfile }) => {
  if (isFetching) {
    return <MSpinner/>;
  }

  const roleName = userProfile.isCustomerService ? "Customer Service Rep" : (userProfile.isMortgageBroker ? "Mortgage Broker"
    : (userProfile.isAppraiserManager ? "Appraiser Manager" : "Appraiser"));

  if (userProfile.isMortgageBroker) 
    return (
      <Card className="md-cell md-cell--12">
        <CardContent><Typography variant="h6">Profile</Typography></CardContent>
        <CardContent className="md-grid">
          <div className="md-cell md-cell--4">
            <ReadOnlyField className="md-cell md-cell--4" title="Welcome" fieldValue={`${userProfile.firstName} ${userProfile.lastName}`} />
          </div>
          <div className="md-cell md-cell--4">
            <ReadOnlyField title="Company" fieldValue={profile.companyName ? profile.companyName : "Mueller Services"} />
          </div>
          <div className="md-cell md-cell--4">
            <ReadOnlyField title="Role" fieldValue={roleName} />
          </div>
        </CardContent>
      </Card>
    );
  
  return (
    <Card className="md-cell md-cell--4">
      <CardContent><Typography variant="h6">Profile</Typography></CardContent>
      <CardContent>
        <ReadOnlyField title="Welcome" fieldValue={`${userProfile.firstName} ${userProfile.lastName}`} />
        <ReadOnlyField title="Company" fieldValue={profile.companyName ? profile.companyName : "Mueller Services"} />
        <ReadOnlyField title="Role" fieldValue={roleName} />
        <ReadOnlyField title="Manager" fieldValue={profile.appraiserManager} />
      </CardContent>
    </Card>
  );
};

Profile.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,
  userProfile: PropTypes.object.isRequired
};

export default Profile;